import React, { useEffect, useRef } from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import './MentionsLostModal.css';
import {
  CallToActionPrimary,
  CallToActionSecondary
} from '../CallToAction/CallToAction';

const MentionsLostModal = ({ onClose, onConfirm }) => {
  const modalRef = useRef();

  const cancelAndClose = () => {
    onClose();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        cancelAndClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalRef]);

  const selectCommunityAndClose = () => {
    onConfirm();
  };

  return (
    <div styleName="container" ref={modalRef}>
      <span styleName="header">{i18next.t('mentionsLost')}</span>
      <span styleName="text">{i18next.t('mentionsLostByCommunity')}</span>
      <hr />
      <div styleName="wrapper">
        <CallToActionSecondary
          label={i18next.t('cancel', 'cancel')}
          size="small"
          onClick={cancelAndClose}
        />
        <CallToActionPrimary
          label={i18next.t('continue', 'continue')}
          size="small"
          onClick={selectCommunityAndClose}
        />
      </div>
    </div>
  );
};

MentionsLostModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default MentionsLostModal;
